export interface QuickBooksDesktopInstanceConstructor {
  id: number
  url: string // QuickBooks company file (.qbw) path
}

export class QuickBooksDesktopInstance {
  readonly id: number
  readonly url: string

  constructor(data: QuickBooksDesktopInstanceConstructor) {
    this.id = data.id
    this.url = data.url
  }

  // A company file path is valid only when it ends with `.qbw`
  // (Integration.options.quickbooks.validFormats). Case-insensitive —
  // the Angular modal checked case-insensitively while the General tab
  // checked case-sensitively; React unifies on the modal behavior
  // (BHV-002).
  static isValidCompanyFilePath(path: string): boolean {
    return path.toLowerCase().endsWith('.qbw')
  }
}
